// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3Uy0a","row":"ProcedureTreatmentSummary_row__3mpCI"};